import { styled } from '@mui/material'

export const Root = styled('div')`
  padding: 30px 0 30px;
  width: 100%;
`

export const Navigation = styled('section')`
  width: 100%;
`
